module.exports = __webpack_public_path__ + "img/skating003.ca1be333.jpg";